import { Outlet, Navigate } from "react-router-dom"; 


const ProtectedRoutes = () => {
    var userToken = sessionStorage.getItem('userToken');
    if (userToken === null) {
        return <Navigate to="/" />;
    } else {
        return <Outlet />;
    }
}

export default ProtectedRoutes;